<div class="enrollment-header">
  <div>
    <button *ngIf="currentStepNumber !== 1" (click)="goBack()" aria-label="Back">
      <mat-icon [class.disabled]="isFirstStep()">arrow_back</mat-icon>
    </button>
  </div>
  <div>
    <!-- Step Information and Dropdown -->
    <span class="step-info">
      STEP {{ currentStepNumber }} OF {{ steps.length }}:
    </span>
    <mat-select [(ngModel)]="currentStep" (selectionChange)="onStepChange($event)">
      <mat-option *ngFor="let step of steps" [value]="step.enrollmentRoute" [disabled]="step.disabled">
        {{ step.enrollmentStepName }}
      </mat-option>
    </mat-select>
  </div>
</div>

<div style="background-color: white; padding: 24px;">
  <router-outlet></router-outlet>
</div>